<template>
  <div class="block">
    <div class="banner">
      <el-carousel height="400px" style="width: 930px;position: absolute;">
        <el-carousel-item v-for="item in data" :key="item.id">
          <img :src="item.image" style="width: 930px;height: 400px;" alt="">
        </el-carousel-item>
      </el-carousel>
    </div>

    <div class="ai">
      <p style="text-align: center;font-size: 18px;margin:19px 13px;font-weight: normal;">高考倒计时</p>
      <p>距离高考还有<span style="color: #C10B17;font-weight: bold;">{{time}}</span>天</p>
      <div class="flex line1">
        <span>高考省份</span>
        <div>{{province}}
        </div>
      </div>
      <div class="flex line1">
        <span>高考模式</span>
        <div v-if="type==1">文理分科</div>
        <div v-if="type==2">新高考3+1+2</div>
        <div v-if="type==3">新高考3+3</div>
      </div>
      <div class="flex line1" v-if="type=='1'">
        <span>高考科目</span>
        <div> <template>
            <el-radio-group v-model="userInfo.subject_type_1" fill="#C10B17" text-color='#C10B17'>
              <el-radio :label="2" fill="#C10B17" text-color='#C10B17'>文科</el-radio>
              <el-radio :label="1">理科</el-radio>
            </el-radio-group>
          </template>
        </div>
      </div>
      <!-- 3+3 3+1+2 -->
      <div v-if="type=='2'">
        <div class="flex line1">
          <span>首选科目</span>
          <div> <template>
              <el-radio-group v-model="radio" fill="#C10B17" text-color='#C10B17'>
                <el-radio :label="1" fill="#C10B17" text-color='#C10B17'>物理</el-radio>
                <el-radio :label="4" fill="#C10B17" text-color='#C10B17'>历史</el-radio>
              </el-radio-group>
            </template>
          </div>
        </div>
        <div class="flex line1">
          <span>再选科目</span>
          <div> <template>

              <el-checkbox-group v-model="checkedCities" text-color='#C10B17' fill='#C10B17' :max="2"
                style="text-align: left;margin-top: 10px;">
                <el-checkbox v-for="item in options2" :label="item.value" :key="item.value" text-color='#C10B17'
                  fill='#C10B17'>{{item.label}}</el-checkbox>
              </el-checkbox-group>
              <!--   <el-radio-group v-model="radio2" fill="#C10B17" text-color='#C10B17'>
                <el-radio :label="5" fill="#C10B17" text-color='#C10B17'>政治</el-radio>
                <el-radio :label="6">化学</el-radio>
              </el-radio-group> -->
            </template>
          </div>
        </div>
      </div>
      <div class="flex line1" v-if="type==3">
        <span>选择科目</span>
        <el-checkbox-group v-model="checkedCities" text-color='#C10B17' fill='#C10B17' :max="3"
          style="text-align: left;margin-top: 10px;">
          <el-checkbox v-for="item in options1" :label="item.value" :key="item.value" text-color='#C10B17'
            fill='#C10B17'>{{item.label}}</el-checkbox>
        </el-checkbox-group>
      </div>
      <div class="line3 flex">
        <el-input style="width: 200px;" v-model="userInfo.score" placeholder="请输入分数">
        </el-input>
        <button class="submit" @click="save()">确定

        </button>
      </div>
      <div class="flex" style="justify-content: space-between;margin:0px 13px;">
        <button class="submit" @click="go(1)">智能填报
          <span class="light"></span>
        </button>
        <button class="submit" @click="go(2)">人工志愿
          <span class="light"></span>
        </button>
      </div>
    </div>
  </div>

</template>

<script>
  export default {
    data() {
      return {
        radio: 1,
        radio1: 1,
        radio2: 1,
        checkedCities: [],
        data: [],
        options2: [{
            value: 2,
            label: "化学"
          }, {
            value: 3,
            label: "生物"
          }, {
            value: 5,
            label: "政治"
          },
          {
            value: 6,
            label: "地理"
          }
        ],
        options1: [{
            value: 1,
            label: "物理"
          }, {
            value: 2,
            label: "化学"
          }, {
            value: 3,
            label: "生物"
          }, {
            value: 4,
            label: "历史"
          }, {
            value: 5,
            label: "政治"
          },
          {
            value: 6,
            label: "地理"
          }
        ],
        type: '',
        score: '',

        options: [{
          value: '选项1',
          label: '本科一批'
        }, {
          value: '选项2',
          label: '本科二批'
        }, {
          value: '选项3',
          label: '专科批'
        }],
        value: '',
        time: '',
        province: '河南',
        selectList: [],
        userInfo: []
      }
    },
    created() {
      if (localStorage.getItem('select')) {
        this.selectList = localStorage.getItem('select')
      }
      this.$http.getUserInfo().then(res => {
        this.userInfo = res.data
        this.type = res.data.subject_mod
        this.radio = Number(this.userInfo.subject_type_1)
        this.province_name = res.data.province_name
        this.checkedCities = res.data.subject_type_2.split(',').map(Number)
        this.userInfo.subject_type_1 = Number(this.userInfo.subject_type_1)
        this.userInfo.subject_type_2 = res.data.subject_type_2.split(',').map(Number)
      })
      this.$http.banner({
        cate_id: 9
      }).then(res => {
        for (let i = 0; i < res.data.list.length; i++) {
          res.data.list[i].image = 'https://yunzhixuanpro.fw366.cn' + res.data.list[i].thumb + ''
        }
        this.data = res.data.list
      })
      this.$http.index({
        pc: 1
      }).then(res => {
        var EndTime = new Date(res.data.exam_time * 1000);
        var NowTime = new Date();
        var t = EndTime.getTime() - NowTime.getTime();
        var res1 = Math.floor(t / 1000 / 60 / 60 / 24) > 0 ? Math.floor(t / 1000 / 60 / 60 / 24) : 0;
        this.time = res1
      })
    },
    methods: {
      save() {
        this.userInfo.subject_type_2 = this.checkedCities
        // this.userInfo.subject_type_1 = this.radio
        this.$http.userInfo(this.userInfo).then(res => {
          if (res.code == 200) {
            this.$message.success('修改成功')
            this.$http.getUserInfo().then(res => {
              localStorage.setItem('userInfo', JSON.stringify(res.data))
              window.location.reload()
            })
          }
        })
      },
      go(num) {
        if (num == 2) {
          localStorage.setItem('activeurl', '/artificialList?type=score')
          this.$router.push({
            path: '/artificialList?type=score'
          })
        } else {
          localStorage.setItem('activeurl', '/aiList')
          this.$router.push({
            path: '/aiList'
          })
        }

      }
    }
  }
</script>

<style scoped lang="scss">
  $color: #C10B17;

  .submit {
    border: none;
    outline: none;
    width: 150px;
    height: 40px;
    line-height: 40px;
    background: $color;
    border-radius: 6px;
    color: #FFFFFF;
    margin-top: 20px;
    font-size: 16px;
    position: relative;
    overflow: hidden;
  }

  .light {
    content: '';
    display: block;
    position: absolute;
    left: -100%;
    width: 120px;
    height: 20px;
    transform: rotate(-65deg);
    background: rgba(255, 255, 255, .5);
    animation: cross 1.5s linear infinite
  }

  @keyframes cross {
    from {}

    to {
      left: 100%;
      transform: rotate(-65deg);
    }
  }

  .el-radio__inne {
    background: red !important;
  }

  .line1 {
    margin: 0 13px 17px 13px;
    justify-content: space-between;
  }

  .line2 {
    justify-content: space-between;
    margin: 0 13px 27px 13px;
  }

  .line1 span {
    margin-right: 60px;
  }

  .ai {
    position: absolute;
    width: 350px;
    height: 400px;
    background-color: #ffffff;
    z-index: 999;
    right: 0px;
    top: 0;
    text-align: center;

    p {
      margin: 19px 13px;
      text-align: left;
      font-size: 20px
    }
  }

  .block {
    width: 1280px;
    height: 400px;
    margin: 0 auto 20px auto;
    position: relative;
  }

  .banner {
    width: 930px;
    height: 400px;
    position: relative;
  }

  .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 250px;
    margin: 0;
  }

  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }

  .line3 {
    margin: 20px 15px;
    align-items: center;
    justify-content: space-between;

    button {
      width: 100px;
      margin-top: 0;
    }
  }
</style>
<style lang="scss">
  // 添加颜色类
  .el-radio__input.is-checked+.el-radio__label {
    color: #C10B17 !important;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: #C10B17 !important;
    border-color: #C10B17 !important;
  }

  .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    border-color: #C10B17 !important;
    background-color: #C10B17 !important;
  }

  .el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #C10B17 !important;
  }

  //修改选中后文本的颜色
  .el-checkbox__input.is-checked+.el-checkbox__label {
    color: #C10B17 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/banner.vue